import type { AuditLogEvent } from '../../../domain/audit-log-event'

import { Typography } from 'antd'

import { AuditLogAction } from '../../../domain/audit-log-action.enum'
import { AuditLogResourceType } from '../../../domain/audit-log-resource-type.enum'

interface Props {
  auditLog: AuditLogEvent
}

export const GroupUpdateResourceColumn = (props: Props): JSX.Element | null => {
  if (
    props.auditLog.resource?.type !== AuditLogResourceType.Group ||
    props.auditLog.action !== AuditLogAction.Update
  ) {
    return null
  }

  const auditLogResource = props.auditLog.resource
  const groupName = auditLogResource.name
  const groupNumber = auditLogResource.number

  const searchParams = new URLSearchParams([['query', groupNumber?.toLowerCase()]])

  return (
    <span>
      <Typography.Link href={`/groups/scheduler?${searchParams.toString()}`} target='_blank'>
        {groupNumber}{' '}
      </Typography.Link>

      <span>{groupName}</span>
    </span>
  )
}
